import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import AddAIBriefPane from "./AddAIBriefPane";
import { RootState } from "src/redux/reducers";
import { API_URLS } from "src/utils/API_URLS";
import { wsAxiosDelete, wsAxiosPut } from "src/helpers/wsAxios";
import { uploadBriefForExistingProject } from "./utils";
import { getProject, setLoadingBrief } from "src/redux";
import useGetProjectBriefData from "src/app/project/hooks/useGetProjectBriefData";

interface AddAIBriefNewProjectPaneProps {
  onClose: () => void;
  isActivateProjectPaneOpen: boolean;
}

export default function AddAIBriefPaneExistingProject({
  onClose,
}: AddAIBriefNewProjectPaneProps) {
  const { projectBasicData, isLoadingBrief } = useSelector(
    (state: RootState) => state.projectReducer,
  );

  const { activeWorkspaceUuid } = useSelector(
    (state: RootState) => state.mainReducer,
  );

  const dispatch = useDispatch();

  const { briefName, briefContent, briefMetaFieldUuid, briefFileData } =
    useGetProjectBriefData();

  const projectUuid = projectBasicData?.projectId || "";
  const briefAssetUuid = briefFileData?.assetId || "";
  const briefUrl =
    briefFileData?.publicDownloadUrl || briefFileData?.publicPreviewUrl;

  const updateProject = () => {
    dispatch(getProject(projectUuid));
  };

  const handleUploadFile = async (file: File): Promise<string | undefined> => {
    dispatch(setLoadingBrief(true));

    try {
      const response = await uploadBriefForExistingProject({
        file,
        wsMetaFieldUuid: briefMetaFieldUuid,
        wsProjectUuid: projectUuid,
        wsWorkspaceUuid: activeWorkspaceUuid,
      });
      if (response) {
        updateProject();
        return response.result;
      }
    } finally {
      dispatch(setLoadingBrief(false));
    }
  };

  const handleSaveRequirements = (requirements: string) => {
    wsAxiosPut(
      API_URLS.setProjectAiFileAnalysis,
      {
        wsProjectUuid: projectUuid,
        metaFieldUuid: briefMetaFieldUuid,
        content: requirements,
      },
      "ws_error_while_applying_requirements",
    );
  };

  const handleRemoveFile = (onSuccess: () => void) => {
    dispatch(setLoadingBrief(true));
    const url = API_URLS.deleteProjectMetaFieldFileAsset
      .replace(":fieldId:", briefMetaFieldUuid)
      .replace(":assetId:", briefAssetUuid);
    wsAxiosDelete({
      url,
      thenCallback: () => {
        onSuccess();
        updateProject();
      },
      finallyCallback: () => {
        dispatch(setLoadingBrief(false));
      },
    });
  };

  useEffect(() => {
    dispatch(getProject(projectUuid));
  }, [dispatch, projectUuid]);

  return (
    <AddAIBriefPane
      onClose={onClose}
      handleUploadFile={handleUploadFile}
      handleRemoveFile={handleRemoveFile}
      handleSaveRequirements={handleSaveRequirements}
      briefContent={briefContent}
      briefName={briefName}
      briefUrl={briefUrl}
      isLoading={isLoadingBrief}
    />
  );
}
